import { render, staticRenderFns } from "./RadarType.vue?vue&type=template&id=f07b8996&scoped=true&"
import script from "./RadarType.vue?vue&type=script&lang=ts&"
export * from "./RadarType.vue?vue&type=script&lang=ts&"
import style0 from "./RadarType.vue?vue&type=style&index=0&id=f07b8996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b8996",
  null
  
)

export default component.exports